import React, { useEffect } from 'react';
import Phaser from 'phaser';
import AttractorTimeout from '../../warning/attractorTimeout';

const PhaserGame = ({ config, fullConfig, passRefUpward, step }) => {

    AttractorTimeout(fullConfig, passRefUpward);

    const containerWidth = 1920;
    const containerHeight = 935;

    useEffect(() => {

        const gameConfig = {
            type: Phaser.AUTO,
            width: containerWidth,
            height: containerHeight,
            parent: 'phaser-canvas',
            physics: {
                default: 'arcade',
                arcade: {
                    debug: false
                }
            },
            scene: {
                preload: preload,
                create: create
            },
            render: {
                transparent: true
            }
        };
        const game = new Phaser.Game(gameConfig);

        return () => {
            game.destroy();
        }
    // eslint-disable-next-line
    }, [])

    function preload () {
        this.load.image('ball-red', 'img/game_icons/track-the-ball/ball-red.svg');
        this.load.image('ball-grey', 'img/game_icons/track-the-ball/ball-grey.svg');
    }

    function create() {
        const scene = this;

        const redBalls = scene.add.group();
        const greyBalls = scene.add.group();

        const redBallNumber = config.number_red_balls;
        const greyBallNumber = config.number_grey_balls;

        scene.physics.add.collider(redBalls, greyBalls);

        loadBalls(scene, redBalls, redBallNumber, 'red');

        scene.tweens.add({
            targets     : redBalls.children.entries,
            scale       : 1,
            ease        : 'Linear',
            duration    : 300,
        });

        const phaserCanvas = document.getElementById('phaser-canvas');

        phaserCanvas.addEventListener('step2Start', () => {
            scene.scene.resume();

            loadBalls(scene, greyBalls, greyBallNumber, 'grey');

            scene.tweens.add({
                targets     : greyBalls.children.entries,
                scale       : 1,
                ease        : 'Linear',
                duration    : 300,
            });
        });

        phaserCanvas.addEventListener('step3Start', () => {
            scene.scene.resume();

            redBalls.getChildren().forEach(ball => {
                ball.setTexture('ball-grey');
            })
        })

        phaserCanvas.addEventListener('step4Start', () => {
            scene.scene.resume();

            redBalls.getChildren().forEach(ball => {
                ball.setTexture('ball-red');
            })
        })

        phaserCanvas.addEventListener('pauseGame', () => {
            scene.scene.pause();
        })
    }

    function loadBalls (scene, ballGroup, number, colour) {

        for (let i = 0; i < number; i++) {
            const ball = scene.physics.add.image(Phaser.Math.Between(100, containerWidth), Phaser.Math.Between(100, containerHeight), `ball-${colour}`);
            ball.setVelocity(Phaser.Math.Between(200, 300), Phaser.Math.Between(200, 300));
            ball.setBounce(1);
            ball.setCollideWorldBounds(true);
            ball.setSize(90, 90);
            ball.setScale(0);
            ballGroup.add(ball);
        }

        scene.physics.add.collider(ballGroup);
    }

    return (
        <div id="phaser-canvas" className="phaser-canvas" ></div>
    );
};

export default PhaserGame;